export default __webpack_public_path__ + "static/media/arrow_down.5254525d.svg";